<div *ngIf="showStatus">{{ status }}</div>
